import React from "react";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";

function AppTargetFilter(props) {
  const { classes } = props;

  const appTargets = [
    {
      value: "0",
      label: "All Versions",
    },
    {
      value: "appv5.js",
      label: "V5",
    },
    {
      value: "app.js",
      label: "V2 & V3 & V4",
    },
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let value = e.target.value;

        switch (value) {
          case "0":
            props.setFilter("appTarget", null);
            break;
          case "NULL":
            props.setFilter("appTarget", { field: "appTarget", operator: null, value: null });
            break;
          default:
            props.setFilter("appTarget", { field: "appTarget", operator: "=", value: value });
            break;
        }
      }}
      style={{ backgroundColor: props.appTarget?.value && props.appTarget?.value != "0" ? "#ff9800" : null }}
      value={props.appTarget?.value ? props.appTarget.value : props.appTarget == null ? "0" : "NULL"}
    >
      {appTargets.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["appTarget"]: state.filtersV2["appTarget"],
  /*   ["vestiging_id"]: state.filtersV2["vestiging_id"], */
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AppTargetFilter, productenStyle));
